function sigLines(company, style) {
  const name = company.signatory_name || "";
  const desig = company.signatory_designation || "Authorised Signatory";
  const contact = `Contact Detail: ${company.email || ""}, ${company.phone || ""}`;
  if (style === "regards") {
    return ["With Regards,", company.company_name, name, desig, company.company_name, contact];
  }
  return [`For ${company.company_name}`, "(Authorized Signature with Seal)", `Name: ${name}`, `Designation: ${desig}`, contact];
}

export default function LetterPreview({ doc, stampUrl }) {
  if (!doc) return null;
  const c = doc.company_snapshot || {};
  const bid = doc.bid_snapshot || {};
  const letter = doc.letter || {};
  const idline = c.gstin ? `GSTIN: ${c.gstin}` : "";
  const backendLogo = c.logo_path ? `${process.env.REACT_APP_BACKEND_URL}/api/company/logo` : null;
  const backendStamp = stampUrl || (c.stamp_path ? `${process.env.REACT_APP_BACKEND_URL}/api/company/stamp` : null);
  const productImg = letter.product_image_id ? `${process.env.REACT_APP_BACKEND_URL}/api/builder/images/${letter.product_image_id}` : null;

  return (
    <div
      data-testid="letter-preview"
      className="a4-paper w-full bg-white paper-shadow rounded-sm overflow-hidden text-slate-900"
    >
      <div className="h-full w-full overflow-y-auto scrollbar-thin px-[9%] py-[7%] text-[11px] leading-relaxed">
        {/* Letterhead */}
        <div className="flex items-start gap-4">
          {backendLogo && (
            <img src={backendLogo} alt="logo" className="h-14 w-auto object-contain" />
          )}
          <div className="min-w-0">
            <div className="font-head text-[19px] font-extrabold tracking-tight leading-tight">{c.company_name}</div>
            {c.mfg_unit && <div className="text-[9px] text-slate-600 mt-0.5">Mfg. Unit: {c.mfg_unit}</div>}
            {idline && <div className="text-[9px] text-slate-600">{idline}</div>}
          </div>
        </div>
        <div className="border-t-2 border-emerald-600 mt-2 mb-4" />

        <div className="mb-3">Date: {bid.bid_date}</div>

        {letter.title && (
          <div className="text-center font-bold text-[13px] my-3 uppercase">{letter.title}</div>
        )}

        <div>To,</div>
        {(c._to_lines || []).map((l, i) => <div key={i}>{l}</div>)}

        <div className="font-semibold mt-3 mb-2">Subject: {letter.subject}</div>

        {letter.salutation && <p className="mb-2">{letter.salutation}</p>}

        {(letter.paragraphs || []).map((p, i) => (
          <p key={i} className="mb-2 text-justify whitespace-pre-line">{p}</p>
        ))}

        {letter.table && (
          <table className="w-full border-collapse my-3 text-[9.5px]">
            <thead>
              <tr className="bg-slate-900 text-white">
                {letter.table.headers.map((h, i) => (
                  <th key={i} className="border border-slate-300 px-2 py-1 text-left font-semibold">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {letter.table.rows.map((row, ri) => {
                const isImageRow = row.length >= 2 && String(row[0]).trim().toLowerCase() === "image";
                return (
                  <tr key={ri} className={ri % 2 ? "bg-slate-50" : "bg-white"}>
                    {row.map((cell, ci) => (
                      <td key={ci} className="border border-slate-300 px-2 py-1 align-top">
                        {isImageRow && ci === 1 && productImg
                          ? <img src={productImg} alt="product" className="max-h-40 w-auto object-contain" data-testid="product-catalogue-image" />
                          : cell}
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}

        {(letter.paragraphs_after || []).map((p, i) => (
          <p key={i} className="mb-2 text-justify">{p}</p>
        ))}

        <div className="mt-8">
          {(() => {
            const lines = sigLines(c, letter.signature_style);
            return (
              <>
                {lines.slice(0, 2).map((l, i) => <div key={`s${i}`}>{l}</div>)}
                {backendStamp && (
                  <img src={backendStamp} alt="stamp" className="h-20 w-20 object-contain my-1" data-testid="letter-stamp" />
                )}
                {lines.slice(2).map((l, i) => <div key={`e${i}`}>{l}</div>)}
              </>
            );
          })()}
        </div>
      </div>
    </div>
  );
}
